import { render } from "./AppScrollable.vue?vue&type=template&id=d9c04bf6"
import script from "./AppScrollable.vue?vue&type=script&lang=js"
export * from "./AppScrollable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__